module.exports = require('./components/Modal');

